export function CorePasswordDirective () {
  
  function isEmpty(value) {
    if (value == null || value == NaN || value == undefined || value == "") return true;
    else return false;
  };

  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ctrl) {
      if (element.parent().find('[popover]').length) {
        scope.$watch(function(){return ctrl.$valid}, function(valid){
          if (!valid && ctrl.$dirty)
            element.parent().find('[popover]').popover('show');
          else if (element.parent().find('[popover]').is(':visible'))
            element.parent().find('[popover]').popover('hide');
        }, true)
        scope.$watch(function(){return ctrl.$dirty}, function(dirty){
          if (dirty && ctrl.$invalid)
            element.parent().find('[popover]').popover('show');
          else if (element.parent().find('[popover]').is(':visible'))
            element.parent().find('[popover]').popover('hide');
        }, true)
      }
      ctrl.$parsers.push(function(value) {
        var regexObj = new RegExp('^(.*?[A-Z]){1,}.*$')
        //convert data from view format to model format
        if (isEmpty(value)) {
          ctrl.$setValidity('$valid', true);
          ctrl.$render();
          return ""
        }
        else if (value.length >= 6 && value.match(regexObj)) {
          ctrl.$setValidity('$valid', true);
          ctrl.$render();
          return value;
        }
        else {
          ctrl.$setValidity('$valid', false);
          ctrl.$render();
          return value
        }
      });

      ctrl.$formatters.push(function(value) {
        //convert data from model format to view format
        if (isEmpty(value)) return "";
        else return value
      });
    }
  }
}